import { render, staticRenderFns } from "./JBZ.vue?vue&type=template&id=2a9a7f4d&scoped=true"
import script from "./JBZ.vue?vue&type=script&lang=js"
export * from "./JBZ.vue?vue&type=script&lang=js"
import style0 from "./JBZ.vue?vue&type=style&index=0&id=2a9a7f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a7f4d",
  null
  
)

export default component.exports